import {useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import FiltersTab from '../../Profiles/DownloadReportPopup/FiltersTab';
import {useGetCurrentSchoolQuery} from '../../../../api/services/schoolManagementService';

export const EMPTY_SETTINGS = {
    groupFilters: [],
    studentFilters: [],
    applicationFilters: [],
    enquiryFilters: [],
    employeeFilters: []
};

export const filterPayload = (settings, strictRecipientsFiltering) => ({
    filterIds: settings.groupFilters.filter(filter => !filter.excluded).map(filter => filter.id),
    excludedFilterIds: settings.groupFilters.filter(filter => filter.excluded).map(filter => filter.id),
    studentIds: [
        ...settings.studentFilters.map(student => student.id),
        ...settings.applicationFilters.map(student => student.id),
        ...settings.enquiryFilters.map(student => student.id)
    ],
    strictRecipientsFiltering
});

export const chosenCount = (settings) =>
    settings.groupFilters.length +
    settings.studentFilters.length +
    settings.applicationFilters.length +
    settings.enquiryFilters.length;

const ReportFilterDialog = ({open, groupFilters, settings, strictRecipientsFiltering, onApply, onClose}) => {
    const [draft, setDraft] = useState(settings);
    const [draftStrict, setDraftStrict] = useState(strictRecipientsFiltering);
    const {data: schoolInfo} = useGetCurrentSchoolQuery();

    const apply = () => {
        onApply(draft, draftStrict);
        onClose();
    };

    const clear = () => {
        setDraft(EMPTY_SETTINGS);
        setDraftStrict(false);
        onApply(EMPTY_SETTINGS, false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Choose who the report covers</DialogTitle>
            <DialogContent>
                <FiltersTab
                    data={groupFilters}
                    settings={draft}
                    setSettings={setDraft}
                    strictRecipientsFiltering={draftStrict}
                    setStrictRecipientsFiltering={setDraftStrict}
                    disableEnquirySelect={schoolInfo == null ? true : schoolInfo.disableEnquiriesSync}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={clear} data-testid="report-filters-clear">Clear</Button>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={apply} data-testid="report-filters-apply">
                    Apply
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ReportFilterDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    groupFilters: PropTypes.array,
    settings: PropTypes.object.isRequired,
    strictRecipientsFiltering: PropTypes.bool,
    onApply: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

export default ReportFilterDialog;
